import { LuBoxes, LuClock, LuTriangleAlert } from "react-icons/lu";

const startOfToday = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

const toISODate = (d) => d.toISOString().slice(0, 10);

export default function InventoryStats({ numItems, numDueToExpire, numExpired, setQuery }) {
  const filterByExpireRange = (fromDate, toDate) => {
    setQuery((prev) => ({
      ...prev,
      item: prev?.item || "",
      addDate: prev?.addDate || [null, null],
      expireDate: [fromDate ? toISODate(fromDate) : "", toDate ? toISODate(toDate) : ""],
      location: prev?.location || "",
      project: prev?.project || "",
      quantity: prev?.quantity || ["", ""],
      catalog: prev?.catalog || "",
      manufacturer: prev?.manufacturer || "",
      supplier: prev?.supplier || "",
      type: prev?.type || "",
    }));
  };

  const cards = [
    {
      key: "total",
      label: "Total Items",
      value: numItems,
      icon: LuBoxes,
      accent: "bg-brand-gradient",
      iconBg: "bg-brand-50 text-brand-600",
      onClick: null,
    },
    {
      key: "due",
      label: "Due to Expire",
      value: numDueToExpire,
      icon: LuClock,
      accent: "bg-amber-500",
      iconBg: "bg-amber-50 text-amber-600",
      onClick: () => filterByExpireRange(startOfToday(), addDays(startOfToday(), 30)),
    },
    {
      key: "expired",
      label: "Expired",
      value: numExpired,
      icon: LuTriangleAlert,
      accent: "bg-rose-500",
      iconBg: "bg-rose-50 text-rose-600",
      onClick: () => filterByExpireRange(null, startOfToday()),
    },
  ];

  return (
    <div className="my-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
      {cards.map(({ key, label, value, icon: Icon, accent, iconBg, onClick }) => (
        <button
          key={key}
          type="button"
          onClick={onClick || undefined}
          disabled={!onClick}
          className={`group relative overflow-hidden rounded-xl border border-gray-200 bg-white p-4 text-left shadow-sm transition ${
            onClick ? "hover:shadow-md hover:border-gray-300 cursor-pointer" : "cursor-default"
          }`}
        >
          <div className={`absolute inset-y-0 left-0 w-1 ${accent}`} />
          <div className="flex items-center gap-4 pl-2">
            <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${iconBg}`}>
              <Icon size={20} />
            </div>
            <div className="min-w-0">
              <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-400">{label}</p>
              <p className="text-2xl font-extrabold leading-tight text-gray-900">{value}</p>
            </div>
          </div>
          {onClick && (
            <p className="mt-2 pl-2 text-[11px] text-gray-400 opacity-0 transition-opacity group-hover:opacity-100">
              Click to filter
            </p>
          )}
        </button>
      ))}
    </div>
  );
}